// extracted by mini-css-extract-plugin
export default {"collapselikebutton":"CollapseLikeButton_collapselikebutton__lNh49"};